<template lang="pug">
	div.cell-wrapper: Cell(
		v-for="(cell, i) in cells",
		:id="i",
		:key="i"
	)
</template>

<script>
	import Cell from '~/components/Cell';

	export default {
		name: 'CellWrapper',
		components: { Cell },
		computed: {
			cells () { return this.$store.state.cells; }
		},
		mounted () {
			this.$store.dispatch('updateInterval');
		}
	};
</script>

<style lang="scss" scoped>
	div.cell-wrapper {
		height: 100vh;
		width: 100vw;
		margin: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: stretch;
	}
</style>
